// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jupzx","question":"styles_question__3Q5aU","description":"styles_description__3EYzg"};